import React, { Component } from "react";
import { Provider } from "react-redux";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
import { history } from "./store";
import { Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";

import store from "./store";
import GlobalStyle from "./theme/globalStyle";

import Buy from "./pages/Buy";
import MoonpayBuy from "./pages/moonpay/Buy";
import MoonpayBuyComplete from "./pages/moonpay/Complete";

import Confirm from "./pages/Confirm";
import Submit from "./pages/Submit";
import Success from "./pages/Success";
import Close from "./pages/Close";

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <GlobalStyle />
          <AlertProvider template={AlertTemplate}>
            <div className="App">
              <BrowserRouter>
                <Routes>
                  <Route path="/" element={<Buy />} />
                  <Route exact path="/moonpay/buy" element={<MoonpayBuy />} />
                  <Route
                    exact
                    path="/moonpay/complete"
                    element={<MoonpayBuyComplete />}
                  />
                  <Route exact path="/confirm" element={<Confirm />} />
                  <Route exact path="/submit" element={<Submit />} />
                  <Route exact path="/success" element={<Success />} />
                  <Route exact path="/close" element={<Close />} />
                </Routes>
              </BrowserRouter>
            </div>
          </AlertProvider>
        </ConnectedRouter>
      </Provider>
    );
  }
}

export default App;
